import { async } from 'q';
import Core from '../core';
import { AxiosError, AxiosResponse } from 'axios';

async function getHeaderNotifications(
  userId: number,
  companyId: number,
  emp_id: number,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/notifications/get?companyId=${companyId}&user_uid=${userId}&emp_id=${emp_id}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}
async function getAllEmpNotifications(
  userId: number,
  companyId: number,
  empId: number,
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/allNotifications/get?companyId=${companyId}&user_uid=${userId}&emp_id=${empId}&locale=${localStorage.getItem(
      'emplang',
    )}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

async function updatereadat(id: number, table: string, empID: number) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/notification/updatereadat?id=${id}&table=${table}&empId=${empID}`,
  );

  if (data instanceof AxiosError) {
    return data.response;
  }
  const response = data.data;
  return response;
}

export const notificationService = {
  getHeaderNotifications,
  getAllEmpNotifications,
  updatereadat,
};
